import { useEffect, useState } from "react";
// Chakra imports
import { Flex, Icon, Image, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
// Assets
import { FaEthereum } from "react-icons/fa";

export default function History(props: {
  image: string;
  name: string;
  author: string;
  date: string;
  price: string | number;
}) {
  const calculateDateDifference = (date1: Date, date2: Date) => {
    const diff = Math.abs(date1.getTime() - date2.getTime());

    const secs = Math.floor(diff / 1000);
    const mins = Math.floor(secs / 60);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);
    if (secs > 60 && mins < 60)
      setDateState(
        mins +
          " minutes et " +
          Math.floor(diff / 1000 - mins * 60) +
          " secondes"
      );
    else if (mins >= 60 && hours < 24)
      setDateState(
        hours +
          " heures et " +
          Math.floor(diff / 60000 - hours * 60) +
          " minutes"
      );
    else if (hours > 24)
      setDateState(
        days +
          " jours et " +
          Math.floor(diff / (60000 * 60) - days * 24) +
          " heures"
      );
    else setDateState(secs + " secondes");
  };

  const { image, name, author, date, price } = props;
  const [dateState, setDateState] = useState(date);
  // Chakra Color Mode
  const textColor = useColorModeValue("brands.900", "white");
  const bgItem = useColorModeValue(
    { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
    { bg: "navy.700", boxShadow: "unset" }
  );
  const textColorDate = useColorModeValue("secondaryGray.600", "white");
  useEffect(() => {
    calculateDateDifference(new Date(), new Date(date));
  }, [dateState]);
  return (
    <Card
      _hover={bgItem}
      bg="transparent"
      boxShadow="unset"
      px="24px"
      py="21px"
      transition="0.2s linear"
    >
      <Flex direction={{ base: "column" }} justify="center">
        <Flex position="relative" align="center">
          <Image src={image} boxSize="70px" borderRadius="20px" me="16px" />
          <Flex
            direction="column"
            w={{ base: "70%", md: "100%" }}
            me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
          >
            <Text
              color={textColor}
              fontSize={{
                base: "md",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {name}
            </Text>
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              {author.slice(0, 80)}
            </Text>
          </Flex>
          <Flex
            me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
            align="center"
          >
            <Icon as={FaEthereum} color={textColor} width="9px" me="7px" />
            <Text fontWeight="700" fontSize="md" color={textColor}>
              {price}
            </Text>
          </Flex>
          <Text ms="auto" fontWeight="700" fontSize="sm" color={textColorDate}>
            {"il y a " + dateState}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
}
